module.exports = __webpack_public_path__ + "static/img/cover13.a5a28e6a.jpg";